<template>
  <div>
    <v-btn icon @click="openDialog()" v-if="this.getDetail.basic.save">
      <v-icon :color="ui.btnColor">
        save
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon left :color="ui.btnColor">
              save
            </v-icon>
            <span :class="ui.textTitle">
              Data Control
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              {{displayDocumentIDGTypeA(getDetailBasic.tag, getDetailBasic.idg)}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip large :color="ui.colorWarning" text-color="white">
                <v-avatar>
                  <v-icon>
                    warning
                  </v-icon>
                </v-avatar>
                <div :class="ui.textSubheadingBoldWhite">
                  Data updating by other user !
                </div>
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.colorWarning" text-color="white">
                <v-avatar>
                  <v-icon>person</v-icon>
                </v-avatar>
                <div :class="ui.textSubheadingBoldWhite">
                  {{getDetail.rev.uname}}
                </div>
              </v-chip>
            </span>
          </v-layout>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.colorWarning" text-color="white">
                <v-avatar>
                  <v-icon>schedule</v-icon>
                </v-avatar>
                <div :class="ui.textSubheadingBoldWhite">
                  {{this.dateTimeAgo(getDetail.stats.dopen)}}
                </div>
              </v-chip>
            </span>
          </v-layout>
          <v-layout row v-if="this.getDetail.basic.id !== ''" class="mt-3">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>title</v-icon>
                </v-avatar>
                {{getDetail.basic.title}}
              </v-chip>
            </span>
          </v-layout>
          <v-layout row v-if="this.getDetail.basic.id !== ''">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>sell</v-icon>
                </v-avatar>
                {{getDetail.basic.id}}
              </v-chip>
            </span>
          </v-layout>
          <v-layout class="mt-0">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> text_snippet </v-icon>
              </v-avatar>
              Document Save Control
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout class="ml-3 mr-3 mt-1">
            <div :class="item.textareaModel">
              {{item.message}}
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="closeDialog" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Return
          </v-btn>
          <v-spacer/>
          <div v-if="btnSpinChangeSaveStatus === false">
            <v-btn
            :color="ui.btnColor"
            @click="changeSaveStatus()"
            flat dark>
            <v-icon left> security </v-icon>
              overwrite
            </v-btn>
          </div>
          <div v-else>
            <BtnSpin dark :btnSpec="btnInfo1"/>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import saveFunctions from "@/data/save/mixins/saveFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";

export default {
  components: {
    BtnSpin
  },
  mixins: [
    apptheme,
    dateFunctions,
    numberFunctions,
    describeDocument,
    displayFunctions,
    saveFunctions,
    docRevsModFunctions
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      btnSpinChangeSaveStatus: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      }
    };
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailSave",
      "getDetailStats",
      "getStatsRemote",
      "getDetail",
      "getPreviousPage"
    ]),
    tag() {
      let tag = this.getDetail.basic.tag;
      return tag;
    },
    item() {
      let obj = {
        message: ""
      };
      // eslint-disable-next-line
      obj.message = "The document is currently being updated by other user or users and access of this document may result in data overwrite condition. The data update inhibit can be changed in system configuration or ask system admin to change the setting.";
      // others
      return obj;
    }
  },
  // eslint-disable-next-line
  props: {
    listIndex: {
      type: Number
    }
  },
  created() {
    let save = this.getDetail.basic.save;
    if (save === false) {
      this.openDialog();
    } else {
      this.setDocumentUpdating();
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      let detail = this.getDetail;
      this.$store.dispatch("changeDetailSave", detail); // used for update
    },
    closeDialog() {
      this.dialog = true;
      // go to previous page
      this.$router.push(this.getPreviousPage);
    },
    changeSaveStatus() {
      this.btnSpinChangeSaveStatus = true;
      this.setDocumentUpdating();
    }
  }
};
</script>
